import React from "react"
import Blocks from "blocks";
import "./accordion-content.scss"

const AccordionContent = ({blocks}) => {
 return blocks.map(block => <Blocks key={block.id} blocks={block.blocks} className={"accordion"} />)
}

export default AccordionContent